import _ from 'underscore';
import { DataSourceState } from '@bingads-webui-react/image-picker'; // eslint-disable-line
import C from '../../constants';

class UserPhotoDataSource {
  constructor(options) {
    this.currentData = [];
    this.hasMore = false;

    this.sortById = options.sortById;
    this.imageRepository = options.imageRepository;

    this.pageSize = 20;
  }

  subscribe(callback) {
    this.callback = callback;
  }

  unsubscribe() {
    this.callback = null;
  }

  excuteCallBackIfExsit(status) {
    /* istanbul ignore else */
    if (this.callback) {
      this.callback(status);
    }
  }

  loadMore() {
    this.currentPage += 1;

    return this.fetchImageAsync();
  }

  reload() {
    this.currentData = [];
    this.currentPage = 0;

    this.excuteCallBackIfExsit(DataSourceState.Done);

    return this.fetchImageAsync();
  }

  searchAsync(searchTerm, sortById, filterTerm = '') {
    this.currentData = [];

    this.excuteCallBackIfExsit(DataSourceState.Done);

    if (searchTerm === null) {
      this.currentSearchTerm = '';
    } else {
      this.currentSearchTerm = searchTerm;
    }

    this.currentFilterTerm = filterTerm;
    this.sortById = sortById || /* istanbul ignore next */this.sortById;
    this.currentPage = 0;

    return this.fetchImageAsync();
  }

  fetchImageAsync() {
    this.excuteCallBackIfExsit(DataSourceState.Loading);

    this.imageRepository.getExistingImages({
      sortById: this.sortById,
      searchTerm: this.currentSearchTerm,
      pageNumber: this.currentPage,
      pageSize: C.pageSize,
      filterTerm: this.currentFilterTerm,
    }).then((response) => {
      this.hasMore = response['@odata.count'] > response.value.length + this.currentData.length;
      const moreData = _.map(response.value, (item) => {
        const src =
          (item.Url.indexOf('http') >= 0) ?
            /* istanbul ignore next */`${item.Url}${((item.Url.indexOf('?') < 0) ? '?' : '')}&h=180` : item.Url;

        return {
          id: parseInt(item.Id, 10),
          idString: item.IdString,
          src,
          source: item.SourceType,
          width: item.Width,
          height: item.Height,
          altText: item.Description || '',
          textFields: [item.Text],
          baseIdString: item.BaseIdString,
          metadata: item.Metadata,
        };
      });

      this.currentData = this.currentData.concat(moreData);
    }).finally(() => {
      this.excuteCallBackIfExsit(DataSourceState.Done);
    });
  }

  getData() {
    return { hasMore: this.hasMore, data: this.currentData };
  }
}

const initializeUserPhotoDataSource = ({
  imageType,
  imageRepository,
}) => {
  const userPhotoDataSource = new UserPhotoDataSource({
    imageRepository,
    imageType,
    sortById: 1,
    /* istanbul ignore next */
    filter: (() => true),
  });

  return userPhotoDataSource;
};

export { UserPhotoDataSource, initializeUserPhotoDataSource };
